import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06f8a92c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-panel" }
const _hoisted_2 = { class: "form-panel-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml10 mr10" }, "手机号", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml10 mr10" }, "验证码", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml10 mr25" }, "新密码", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml10 mr10" }, "确认密码", -1))
const _hoisted_7 = { class: "form-panel-btns" }

import { ref, reactive, watch, onMounted } from 'vue';
import { useVModel } from '@vueuse/core';
import { RuleObject } from 'ant-design-vue/lib/form';
import { SUCCESS_CODE } from '@/lib/api/response_code';
import { getVerCode } from '@/api/system/auth';
import { resetPwd } from '@/api/user';
import { message } from 'ant-design-vue';
import { state as globalState } from '@/modules/global';


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgetPassword',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '忘记密码',
  },
  isFirst: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:visible"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:visible', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





/** 获取的 visible 是父组件的值, 操作的也是父组件的值 */
const visible = useVModel(props, 'visible', emit);

/** 表单标签的索引 用于获取表单标签并操作 */
const formEl = ref();

const state = reactive({
  /** 忘记密码表单 */
  form: {
    /** 手机号 */
    phoneNumber: '',
    /** 验证码 */
    verCode: '',
    /** 新密码 */
    newPassword: '',
    /** 重输新密码 */
    repeatNewPassword: '',
  },
  /** 忘记密码场景 */
  actionKey: '2',
  /**  */
  templateParams: [],
  /** 60秒倒计时 */
  recordTime: 0,
  /** 产品Id */
  productId: 9,
  /** 按钮60秒倒计时 */
  loading: false,
});

/** 固定不变的总的倒计时时间 */
const countTotalTime = 60;
/** 手机号校验 */
const phonePattern = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
/** 验证码校验 */
const verCodePattern = /\d{6}/;
/** 秒与毫秒进制数 */
const smsNum = 1000;

/** 校验两次密码是否一致 */
const validateRepeatNewPassword = async (_rule: RuleObject, value: string) => {
  if (value !== state.form.newPassword) {
    return Promise.reject(new Error('两次输入密码不同'));
  } else {
    return Promise.resolve();
  }
};

const complexPassword = async (_rule, value: string) => {
  const _message = `密码必须包含字母大小写、数字和特殊字符，且长度为8-20位`;
  // 验证特殊符号
  // eslint-disable-next-line prefer-regex-literals
  const _flag = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]");
  if (
    value.match(/^.*[A-Z]+.*$/) &&
    value.match(/^.*[a-z]+.*$/) &&
    value.match(/^.*[0-9]+.*$/) &&
    _flag.test(value) &&
    value.length > 7 &&
    value.length < 21
  ) {
    return Promise.resolve();
  }
  return Promise.reject(_message);
};

/** 表单规则 */
const rules = {
  /** 用户手机号 */
  phoneNumber: [
    { required: true, min: 11, max: 11, message: '请输入手机号码' },
    {
      pattern: phonePattern,
      message: '请输入正确的手机号码',
      trigger: 'blur',
    },
  ],
  /** 验证码 */
  verCode: [
    { required: true, message: '验证码不可为空', trigger: 'blur' },
    {
      pattern: verCodePattern,
      message: '验证码格式应为六位数字',
      trigger: 'blur',
      min: 6,
      max: 6,
    },
  ],
  /** 新密码 */
  newPassword: [
    { validator: complexPassword, trigger: 'blur' },
    { required: true, message: '请输入密码' },
  ],
  /** 再次输入新密码 */
  repeatNewPassword: [
    { required: true, message: '请重新输入新密码' },
    { validator: validateRepeatNewPassword, trigger: 'change' },
  ],
};

/** 表单重置 */
const resetForm = () => {
  state.form = {
    /** 手机号 */
    phoneNumber: globalState.userInfo.phonenumber ?? '',
    /** 验证码 */
    verCode: '',
    /** 新密码 */
    newPassword: '',
    /** 重输新密码 */
    repeatNewPassword: '',
  };
  if (formEl.value) {
    formEl.value.resetFields();
  }
};

const timerCb = () => {
  if (state.recordTime) {
    setTimeout(() => {
      state.recordTime--;
      timerCb();
    }, smsNum);
  }
};

/** 验证码发送之后的60秒倒计时 期间不能重复发送 */
const handleCountDown = () => {
  if (state.recordTime > 0) {
    return;
  } else {
    state.recordTime = countTotalTime;
  }
  timerCb();
};

watch(
  () => props.visible,
  () => {
    resetForm();
  },
);

/** 倒计时在刷新页面之后继续倒计时 */
const pageReloadAndCountTimeNotZero = () => {
  const _recordTime = +localStorage.getItem('reset_pwd_time')!;
  const now_time = new Date().getTime();
  if (_recordTime > now_time) {
    state.recordTime = Math.ceil((_recordTime - now_time) / smsNum);
    timerCb();
  }
};

const onVercodeChange = () => {
  state.form.verCode = state.form.verCode.replace(/\D/g, '');
};

/** 发送验证码 */
const sendVerCode = () => {
  /** 发送验证码之前 查询用户手机号是否在数据库存在 只有存在才能进行下步手机校验的操作和倒计时的操作 */
  formEl.value
    .validate(['phoneNumber'])
    .then(valid => {
      if (valid) {
        getVerCode({
          productId: state.productId,
          actionKey: state.actionKey,
          phoneNumber: state.form.phoneNumber,
          templateParams: [],
        })
          .then(res => {
            if (res.data.code === SUCCESS_CODE) {
              handleCountDown();
              message.success('验证码发送成功');
              localStorage.setItem(`reset_pwd_time`, `${new Date().getTime() + countTotalTime * smsNum}`);
            } else {
              message.error(res.data.msg);
            }
          })
          .catch(() => {});
      } else {
        // message.error('手机号格式错误');
      }
    })
    .catch(() => {
      // message.error('请输入正确的手机号');
    });

  return 0;
};

/** 表单提交 */
const onSubmit = () => {
  formEl.value
    .validate()
    .then(valid => {
      if (valid) {
        resetPwd({
          actionKey: state.actionKey,
          password: state.form.newPassword,
          phoneNumber: state.form.phoneNumber,
          productId: state.productId,
          verificationCode: state.form.verCode,
        })
          .then(() => {
            message.success('成功更换新密码');
            visible.value = false;
            resetForm();
          })
          .catch(() => {
            // message.error('更换新密码失败');
          });
      }
    })
    .catch(() => {
      // message.error('填写信息错误');
    });
};

/** 关闭忘记密码框 */
const closeModal = () => {
  if (props.isFirst) {
    return;
  }
  visible.value = false;
  resetForm();
};

onMounted(() => {
  pageReloadAndCountTimeNotZero();
});
resetForm();

return (_ctx: any,_cache: any) => {
  const _component_phone_outlined = _resolveComponent("phone-outlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_verified_outlined = _resolveComponent("verified-outlined")!
  const _component_unlock_outlined = _resolveComponent("unlock-outlined")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      "destroy-on-close": true,
      visible: _unref(visible),
      title: props.title,
      footer: null,
      closable: false,
      "force-render": true,
      onCancel: closeModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_a_form, {
            ref_key: "formEl",
            ref: formEl,
            rules: rules,
            model: state.form
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_a_form_item, {
                  name: "phoneNumber",
                  size: "large",
                  class: "form-item"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, {
                      type: "flex",
                      justify: "space-between",
                      gutter: 8
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: state.form.phoneNumber,
                              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((state.form.phoneNumber) = $event)),
                              placeholder: "",
                              maxlength: 11,
                              disabled: _unref(globalState).userInfo.phonenumber !== '',
                              onChange: _cache[1] || (_cache[1] = ($event: any) => (state.form.phoneNumber = state.form.phoneNumber.replace(/\D/g, '')))
                            }, {
                              prefix: _withCtx(() => [
                                _createVNode(_component_phone_outlined),
                                _hoisted_3
                              ]),
                              _: 1
                            }, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              disabled: state.recordTime > 0,
                              loading: state.loading,
                              onClick: sendVerCode
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, [
                                  _createTextVNode(" 发送验证码"),
                                  (state.recordTime)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode("(" + _toDisplayString(state.recordTime) + "s)", 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            }, 8, ["disabled", "loading"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "verCode",
                  class: "form-item"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: state.form.verCode,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((state.form.verCode) = $event)),
                      maxlength: 6,
                      placeholder: "",
                      onChange: onVercodeChange
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_verified_outlined),
                        _hoisted_4
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "newPassword",
                  class: "form-item"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_password, {
                      value: state.form.newPassword,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((state.form.newPassword) = $event)),
                      maxlength: 20,
                      placeholder: "包含字母大小写、数字和特殊字符，长度为8-20位",
                      autocomplete: "new-password",
                      onpaste: "return false",
                      ondragenter: "return false",
                      oncontextmenu: "return false",
                      style: {"ime-mode":"disabled"}
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_unlock_outlined),
                        _hoisted_5
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "repeatNewPassword",
                  class: "form-item"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_password, {
                      value: state.form.repeatNewPassword,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((state.form.repeatNewPassword) = $event)),
                      maxlength: 20,
                      placeholder: "两次密码需保持一致",
                      style: {"ime-mode":"disabled"}
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_unlock_outlined),
                        _hoisted_6
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["model"]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_a_button, {
              type: "primary",
              class: "confirm-reset-password-button",
              size: "large",
              onClick: onSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode("确 定")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}
}

})